import { Action } from '@ngrx/store';

import {
  AnalyticsDurationIdentifier,
  DealAnalytics,
  MaturityCouponOverrides
} from '../../types/analytics.types';

export enum AnalyticsActionTypes {
  LoadAnalytics = '[Analytics] Load Analytics',
  LoadBidAnalytics = '[Analytics] Load Bid Analytics',
  LoadAnalyticsFail = '[Analytics] Load Analytics Fail',
  LoadAnalyticsSuccess = '[Analytics] Load Analytics Success',
  LoadBidAnalyticsFail = '[Analytics] Load Bid Analytics Fail',
  LoadBidAnalyticsSuccess = '[Analytics] Load Bid Analytics Success',
  SelectAnalyticsDuration = '[Analytics] Select Analytics Duration',
  OverrideAnalyticsCoupon = '[Analytics] Override Analytics Coupon'
}

export class LoadAnalytics implements Action {
  public readonly type = AnalyticsActionTypes.LoadAnalytics;

  constructor(
    public payload: { dealId: string; overrides: MaturityCouponOverrides }
  ) {}
}
export class LoadBidAnalytics implements Action {
  public readonly type = AnalyticsActionTypes.LoadBidAnalytics;

  constructor(
    public payload: { dealId: string; overrides: MaturityCouponOverrides }
  ) {}
}

export class LoadAnalyticsFail implements Action {
  public readonly type = AnalyticsActionTypes.LoadAnalyticsFail;

  constructor(public payload: { error: string; errorCode: number }) {}
}

export class LoadAnalyticsSuccess implements Action {
  public readonly type = AnalyticsActionTypes.LoadAnalyticsSuccess;

  constructor(public payload: { data: DealAnalytics }) {}
}
export class LoadBidAnalyticsFail implements Action {
  public readonly type = AnalyticsActionTypes.LoadBidAnalyticsFail;

  constructor(public payload: { error: string; errorCode: number }) {}
}

export class LoadBidAnalyticsSuccess implements Action {
  public readonly type = AnalyticsActionTypes.LoadBidAnalyticsSuccess;

  constructor(public payload: { data: DealAnalytics }) {}
}

export class SelectAnalyticsDuration implements Action {
  public readonly type = AnalyticsActionTypes.SelectAnalyticsDuration;

  constructor(public payload: { identifier: AnalyticsDurationIdentifier }) {}
}

export class OverrideAnalyticsCoupon implements Action {
  public readonly type = AnalyticsActionTypes.OverrideAnalyticsCoupon;

  constructor(public payload: MaturityCouponOverrides) {}
}

export type AnalyticsActionUnion =
  | LoadAnalytics
  | LoadAnalyticsFail
  | LoadAnalyticsSuccess
  | LoadBidAnalytics
  | LoadBidAnalyticsFail
  | LoadBidAnalyticsSuccess
  | SelectAnalyticsDuration
  | OverrideAnalyticsCoupon;
